import { z } from 'zod';
import type { Tag } from '../types/tags.js';

/**
 * Tags endpoint Zod schemas for Polymarket Gamma API
 */

export const ListTagsParamsSchema = z.object({
  limit: z.number().optional(),
  offset: z.number().optional(),
  order: z.string().optional(),
  ascending: z.boolean().optional(),
  include_template: z.boolean().optional(),
  is_carousel: z.boolean().optional(),
});

export const GetTagByIdParamsSchema = z.object({
  id: z.number(),
  include_template: z.boolean().optional(),
});

export const GetTagBySlugParamsSchema = z.object({
  slug: z.string(),
  include_template: z.boolean().optional(),
});

export const TagStatusSchema = z.enum(['active', 'closed', 'all']);

export const GetRelatedTagsByIdParamsSchema = z.object({
  id: z.number(),
  omit_empty: z.boolean().optional(),
  status: TagStatusSchema.optional(),
});

export const GetRelatedTagsBySlugParamsSchema = z.object({
  slug: z.string(),
  omit_empty: z.boolean().optional(),
  status: TagStatusSchema.optional(),
});

export const GetTagsRelatedToTagIdParamsSchema = z.object({
  id: z.number(),
  omit_empty: z.boolean().optional(),
  status: TagStatusSchema.optional(),
});

export const GetTagsRelatedToTagSlugParamsSchema = z.object({
  slug: z.string(),
  omit_empty: z.boolean().optional(),
  status: TagStatusSchema.optional(),
});

export const TagSchema: z.ZodType<Tag> = z.lazy(() => z.object({
  id: z.string(),
  label: z.string().nullable().optional(),
  slug: z.string().nullable().optional(),
  forceShow: z.boolean().nullable().optional(),
  publishedAt: z.string().nullable().optional(),
  createdBy: z.number().nullable().optional(),
  updatedBy: z.number().nullable().optional(),
  createdAt: z.string().nullable().optional(),
  updatedAt: z.string().nullable().optional(),
  forceHide: z.boolean().nullable().optional(),
  isCarousel: z.boolean().nullable().optional(),
}));

export const RelatedTagSchema = z.object({
  id: z.string(),
  tagID: z.number().nullable().optional(),
  relatedTagID: z.number().nullable().optional(),
  rank: z.number().nullable().optional(),
});

export const GetTagRelationshipsByIdParamsSchema = GetRelatedTagsByIdParamsSchema;

export const GetTagRelationshipsRequestSchema = GetRelatedTagsByIdParamsSchema;

export const GetRelatedTagsRequestSchema = GetRelatedTagsByIdParamsSchema;
